import {Box, Button, DialogTitle, IconButton, Stack, styled} from '@mui/material';

const StyledDialogTitle = styled(DialogTitle)`
	padding: 16px;
	background-color: ${({theme}) => theme.palette.primary.main};
	color: ${({theme}) => theme.palette.common.white};

	${({theme}) => theme.breakpoints.up('sm')} {
		display: none;
	}
`;

const StyledIconButton = styled(IconButton)`
	position: absolute;
	top: 12px;
	right: 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		display: none;
	}
`;

const StyledImageContainer = styled(Box)`
	flex: 1;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	${({theme}) => theme.breakpoints.up('sm')} {
		height: 257.75px;
		flex: auto;
	}
`;

const StyledStackContent = styled(Stack)`
	padding: 16px;
	align-items: center;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px;
	}
`;

const StyledActionsContainer = styled(Stack)`
	padding: 0px 16px 16px;
	gap: 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
		padding: 0px 24px 24px;

		button {
			flex: 1;
		}
	}
`;

const StyledSkipButton = styled(Button)`
	position: absolute;
	top: 24px;
	right: 24px;
	color: ${({theme}) => theme.palette.primary.main};
	background-color: ${({theme}) => theme.palette.common.white};

	${({theme}) => theme.breakpoints.down('sm')} {
		top: 16px;
		right: 16px;
	}

	&:is(:hover, :disabled) {
		background-color: ${({theme}) => theme.palette.common.white};
	}
`;

const StyledPrevButtonContainer = styled(Box)`
	position: absolute;
	top: 24px;
	left: 24px;

	${({theme}) => theme.breakpoints.down('sm')} {
		top: 16px;
		left: 16px;
	}
`;

export {
	StyledDialogTitle,
	StyledIconButton,
	StyledImageContainer,
	StyledStackContent,
	StyledActionsContainer,
	StyledSkipButton,
	StyledPrevButtonContainer,
};
